import React, { useEffect, useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import { Select, Space, Typography } from "antd";
import useAllTicketStore from "./all_tickets/store";
import { filterOption } from "modules/utilities/utility";
import { useOrderSearchForTicket } from "modules/CreateTicket/store";
import secureLocalStorage from "react-secure-storage";

function UpdateBulkAssignee({ setRefresh, refresh, handleClose }) {
  const { crmCategories } = useOrderSearchForTicket();
  const {
    rowChecked,
    bulkTicketUpdated,
    setRowChecked,
    fetchAllActiveAssignee,
    fetchResolvedAssignees,
    allAssigneeData = [],
    resolvedAssigneeData = [],
  } = useAllTicketStore();
  const [assignee, setAssignee] = useState("");

  useEffect(() => {
    const fetchAssignees =  () => {
       fetchAllActiveAssignee();
       fetchResolvedAssignees();
    };

    fetchAssignees();
  }, [fetchAllActiveAssignee, fetchResolvedAssignees]);

  const assigneeOptions = useMemo(() => {
    const activeAssignees = Array.isArray(allAssigneeData?.data?.assignees)
      ? allAssigneeData?.data?.assignees?.map((assignee) => ({
          label: assignee.firstName,
          value: assignee.userId,
        }))
      : [];

    const resolvedAssignees = Array.isArray(resolvedAssigneeData.assignees)
      ? resolvedAssigneeData.assignees.map((assignee) => ({
          label: assignee.firstName,
          value: assignee.userId,
        }))
      : [];

    const combinedAssignees = [...activeAssignees, ...resolvedAssignees];
    const uniqueAssignees = combinedAssignees.reduce(
      (acc, user) => ({ ...acc, [user.value]: user }),
      {}
    );
    return Object.values(uniqueAssignees);
  }, [allAssigneeData, resolvedAssigneeData]);

  const handleBulkOperations = async () => {
    const payload = {
      ticketIds: rowChecked,
      current_assignment: assignee,
      action_taker: secureLocalStorage.getItem("id"),
    };
    await bulkTicketUpdated(payload);
    setRefresh(!refresh);
    handleClose();
    setRowChecked([]);
  };

  const handleSelect = (data) => setAssignee(data);

  return (
    <>
      <h2 className="my-4">Bulk Operation</h2>
      <Space.Compact block className="my-2">
        <span
          style={{ background: "#FAFAFA", border: "#D9D9D9", width: "30%" }}
          className="border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2"
        >
          <Typography.Text>Select Assignees</Typography.Text>
        </span>
        <Select
          style={{ width: "70%" }}
          showSearch
          allowClear
          placeholder="Assignees"
          optionFilterProp="children"
          onChange={handleSelect}
          filterOption={filterOption}
          options={assigneeOptions}
        />
      </Space.Compact>
      <Button variant="primary" className="mt-4" onClick={handleBulkOperations}>
        Bulk Operation
      </Button>
    </>
  );
}

export default UpdateBulkAssignee;
